import type { Icon } from '@phosphor-icons/react'

export interface NavDef {
  id: string
  label: string
  to: string
  icon: Icon
  keys?: string
  /** Sidebar group id (SiteConfig.groups). */
  group: string
  /** Permission (any of) needed to see it; omitted = everyone signed in. */
  needs?: readonly string[]
  /** Professional workspace only (any role beyond contributor). */
  professional?: boolean
  bottom?: boolean
  /** Other path prefixes that belong to this section (pages it absorbed, detail pages kept at their old address). */
  also?: readonly string[]
  /** App frame: false keeps it out of the top bar and bottom tabs (still in the palette and shortcuts). */
  bar?: boolean
  /** App frame: a shorter label for the phone's bottom tabs. */
  short?: string
  keywords?: readonly string[]
  description?: string
}

/** ``team``: a team-only member, who sees just the pages an admin turned on (``page:<id>`` grants) and the overview. */
export function visibleNav(nav: readonly NavDef[], perms: ReadonlySet<string>, professional: boolean, team = false): NavDef[] {
  return nav.filter((n) => (!n.professional || professional) && (!n.needs || n.needs.some((p) => perms.has(p)))
    && (!team || n.id === 'overview' || perms.has(`page:${n.id}`)))
}

/** Longest matching nav entry for a pathname (detail pages light up their section). */
export function activeNav(pathname: string, items: readonly NavDef[]): NavDef | undefined {
  let best: NavDef | undefined
  for (const n of items) {
    for (const to of [n.to, ...(n.also ?? [])]) {
      const hit = to === '/' ? pathname === '/' : pathname === to || pathname.startsWith(`${to}/`)
      if (hit && (!best || to.length > best.to.length)) best = { ...n, to }
    }
  }
  return best && items.find((n) => n.id === best!.id)
}
